import type { SVGProps } from "react";

import * as React from "react";

export const HealthInsuranceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <path
      fill="#FFAC96"
      d="m125.68 242.16-36.24-104.4a25 25 0 0 0-28.48-18.56 24.07 24.07 0 0 0-15.48 10.932 24.06 24.06 0 0 0-2.76 18.748L80 264zM386.32 242.16l36.24-104.4a25 25 0 0 1 28.48-18.56 24.06 24.06 0 0 1 15.479 10.932 24.049 24.049 0 0 1 2.761 18.748L432 264z"
    />
    <path
      fill="#FFBCAB"
      d="M200.368 285.456 129.648 244a23.954 23.954 0 0 0-30.4 5.432L73.44 169.76a25 25 0 0 0-28.48-18.56 24.07 24.07 0 0 0-15.48 10.932 24.06 24.06 0 0 0-2.76 18.748l34.8 129.84a31.6 31.6 0 0 0 9.68 15.68l54.08 48.08a32 32 0 0 1 7.922 10.812A32 32 0 0 1 136 398.4V424h96v-83.328a64 64 0 0 0-31.632-55.216M467.04 151.2a25 25 0 0 0-28.48 18.56l-25.84 79.672a23.95 23.95 0 0 0-30.4-5.432l-70.72 41.456a64 64 0 0 0-31.6 55.216V424h96v-25.6a32 32 0 0 1 2.798-13.108 32 32 0 0 1 7.922-10.812l54.08-48.08a31.58 31.58 0 0 0 9.68-15.68l34.8-129.84a24.05 24.05 0 0 0-2.761-18.748A24.05 24.05 0 0 0 467.04 151.2"
    />
    <path fill="#006DF0" d="M272 424v64h112v-64H272M240 424H128v64h112z" />
    <path
      fill="#D80027"
      d="m363.52 148.481-5.68 5.68L256 256.001l-101.84-101.84-5.68-5.68a72 72 0 0 1-22.166-51.228A71.998 71.998 0 0 1 250.32 46.72L256 52.4l5.68-5.68a72 72 0 0 1 79.181-16.888 72 72 0 0 1 22.659 118.648"
    />
    <path
      fill="#BD0022"
      d="M363.52 46.72a71.2 71.2 0 0 0-58.944-20.631 71.953 71.953 0 0 1 42.944 122.4l-5.68 5.68L248 248.001l8 8 101.84-101.84 5.68-5.68a72 72 0 0 0 0-101.76"
    />
    <path fill="#F1F2F2" d="M272 176v-32h32v-32h-32V80h-32v32h-32v32h32v32z" />
    <path
      fill="#FFAC96"
      d="m406.352 269.601-53.472 29.6a6.935 6.935 0 0 0-.993 11.306 6.92 6.92 0 0 0 7.921.694l46.544-25.6a23.999 23.999 0 0 0 10.552-28.872 23.77 23.77 0 0 1-10.552 12.872M105.648 269.601l53.472 29.6a6.935 6.935 0 0 1 .993 11.306 6.92 6.92 0 0 1-7.921.694l-46.544-25.6a24 24 0 0 1-10.552-28.872 23.77 23.77 0 0 0 10.552 12.872"
    />
  </svg>
);


export const PaidTimeOffIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <path
      fill="#E4E3FF"
      d="M496.942 163.805v277.389c0 29.351-23.807 53.158-53.209 53.158H68.269c-29.352 0-53.21-23.807-53.21-53.158V163.805z"
    />
    <path
      fill="#fff"
      d="M450.58 415.32c0 12.936-10.486 23.422-23.422 23.422H84.853c-12.935 0-23.421-10.486-23.421-23.422V235.383c0-12.936 10.486-23.422 23.421-23.422h342.305c12.936 0 23.422 10.486 23.422 23.422z"
    />
    <path
      fill="#474646"
      d="M210.644 387.155a5.09 5.09 0 0 1-4.65-3.018l-44.153-99.036a5.087 5.087 0 1 1 9.29-4.143l44.152 99.036a5.087 5.087 0 0 1-4.639 7.161"
    />
    <path
      fill="#7979F7"
      d="M120.308 321.869c-2.505.992-5.287-.411-6.075-2.987-9.263-30.31 6.176-63.154 36.119-75.017 29.98-11.878 63.725 1.48 77.733 29.91 1.191 2.416.124 5.344-2.38 6.336z"
    />
    <path
      fill="#5E5EEF"
      d="m225.708 280.1-105.401 41.764c-2.492 1.017-5.29-.407-6.053-3.002a52 52 0 0 1-1.374-5.392l82.742-32.826c10.528-4.176 13.549-17.564 5.918-25.932-4.798-5.261-11.392-10.614-20.393-14.595 19.737 2.645 37.643 14.854 46.952 33.675 1.17 2.392.102 5.342-2.391 6.308"
    />
    <path
      fill="#F9B938"
      d="M152.8 308.996c-12.5-31.55-13.584-60.719-2.436-65.136 11.161-4.422 30.348 17.576 42.848 49.125z"
    />
    <path
      fill="#ECB021"
      d="m193.202 292.97-40.39 16.024a143 143 0 0 1-3.51-9.767l15.318-6.088c9.37-3.724 13.254-14.782 8.5-23.674-6.054-11.325-12.772-20.436-19.087-26.092 11.344.712 27.927 21.263 39.169 49.597"
    />
    <path
      fill="#FC6559"
      d="M496.942 124.533v39.271H15.06v-39.271c0-29.402 23.857-53.209 53.209-53.209h375.464c29.402 0 53.209 23.807 53.209 53.209"
    />
    <path
      fill="#F05543"
      d="M496.941 124.54v39.271H15.059v-20.297h432.416c13.947 0 25.253-11.306 25.253-25.253v-14.018c0-10.631-3.103-20.5-8.444-28.792 19.177 8.038 32.657 26.961 32.657 49.089"
    />
    <path
      fill="#D0D0F7"
      d="M496.942 163.805v277.389c0 29.351-23.807 53.158-53.209 53.158H68.268c-22.077 0-41.05-13.48-49.088-32.607 7.63 4.273 16.481 6.715 25.892 6.715h375.465c29.402 0 53.208-23.807 53.208-53.159V163.805z"
    />
    <path
      fill="#F7C9A9"
      d="M258.721 395.515a159 159 0 0 0-46.8 43.239H84.851c-12.921 0-23.4-10.479-23.4-23.451v-12.514c28.74-22.077 64.705-35.201 103.722-35.201 34.54 0 66.689 10.276 93.548 27.927"
    />
    <path
      fill="#F0B68E"
      d="M258.723 395.514a159 159 0 0 0-46.799 43.239H84.853c-12.056 0-22.027-9.156-23.298-20.958a23.14 23.14 0 0 0 13.582 4.375h120.858c3.912 0 7.532-1.888 9.938-4.972a157.3 157.3 0 0 1 34.07-32.315 158 158 0 0 1 18.72 10.631"
    />
    <path
      fill="#F7C9A9"
      d="M450.549 416.781c-.763 12.311-10.988 21.976-23.4 21.976H211.922a159 159 0 0 1 46.8-43.239c23.908-14.548 52.039-22.891 82.051-22.891 42.629 0 81.289 16.838 109.776 44.154"
    />
    <path
      fill="#F0B68E"
      d="M450.549 416.779c-.763 12.31-10.988 21.975-23.4 21.975H211.922c4.019-5.595 8.343-10.885 13.124-15.871h189.793c10.784 0 19.94-7.274 22.636-17.295a144 144 0 0 1 13.074 11.191"
    />
    <path
      fill="#474646"
      d="M156.275 40.37v57.86c0 12.55-10.174 22.724-22.724 22.724-12.549 0-22.723-10.174-22.723-22.723V40.37c0-12.55 10.174-22.723 22.723-22.723 12.55 0 22.724 10.173 22.724 22.723M401.184 40.37v57.86c0 12.55-10.173 22.724-22.723 22.724s-22.723-10.174-22.723-22.723V40.37c0-12.55 10.173-22.723 22.723-22.723s22.723 10.173 22.723 22.723"
    />
    <path
      fill="#2D2C2C"
      d="M156.271 40.346v57.889c0 12.565-10.174 22.738-22.739 22.738-6.257 0-11.903-2.543-16.023-6.664a22.2 22.2 0 0 1-5.291-8.393 22 22 0 0 0 6.664 1.017c12.565 0 22.738-10.173 22.738-22.738V26.306c0-2.696-.457-5.24-1.322-7.63a22.74 22.74 0 0 1 9.309 5.646c4.12 4.12 6.664 9.767 6.664 16.024M401.207 40.346v57.889c0 12.565-10.174 22.738-22.739 22.738a22.69 22.69 0 0 1-16.075-6.664 22.2 22.2 0 0 1-5.29-8.393 22.6 22.6 0 0 0 6.715 1.017c12.564 0 22.738-10.173 22.738-22.738V26.306c0-2.696-.458-5.24-1.322-7.63a22.75 22.75 0 0 1 9.308 5.646c4.121 4.12 6.665 9.767 6.665 16.024"
    />
    <path
      fill="#FC6559"
      d="M356.654 293.57c0 16.86-13.662 30.522-30.522 30.522s-30.561-13.662-30.561-30.522 13.701-30.521 30.561-30.521 30.522 13.661 30.522 30.521"
    />
    <path
      fill="#E24B40"
      d="M356.645 293.573c0 16.85-13.669 30.519-30.519 30.519-10.37 0-19.502-5.126-25.04-13.08a29.9 29.9 0 0 0 12.372 2.651c16.85 0 30.519-13.668 30.519-30.519 0-6.48-2.003-12.49-5.479-17.439a30.4 30.4 0 0 1 18.147 27.868"
    />
    <path
      fill="#474646"
      d="M326.112 253.367a5.086 5.086 0 0 1-5.087-5.087v-9.469a5.085 5.085 0 0 1 5.087-5.086 5.085 5.085 0 0 1 5.087 5.086v9.469a5.086 5.086 0 0 1-5.087 5.087M294.091 266.636a5.07 5.07 0 0 1-3.597-1.49l-6.696-6.697a5.085 5.085 0 0 1 0-7.193 5.085 5.085 0 0 1 7.193 0l6.696 6.696a5.086 5.086 0 0 1-3.596 8.684M280.82 298.654h-9.468a5.085 5.085 0 0 1-5.087-5.087 5.086 5.086 0 0 1 5.087-5.087h9.468a5.086 5.086 0 0 1 5.087 5.087 5.085 5.085 0 0 1-5.087 5.087M287.394 337.38a5.086 5.086 0 0 1-3.597-8.684l6.696-6.696a5.086 5.086 0 1 1 7.194 7.193l-6.697 6.697a5.07 5.07 0 0 1-3.596 1.49M326.112 353.418a5.086 5.086 0 0 1-5.087-5.087v-9.469a5.086 5.086 0 0 1 5.087-5.087 5.086 5.086 0 0 1 5.087 5.087v9.469a5.086 5.086 0 0 1-5.087 5.087M364.833 337.38a5.07 5.07 0 0 1-3.597-1.49l-6.696-6.697a5.085 5.085 0 0 1 0-7.193 5.085 5.085 0 0 1 7.193 0l6.696 6.696a5.086 5.086 0 0 1-3.596 8.684M380.869 298.654h-9.468a5.085 5.085 0 0 1-5.087-5.087 5.086 5.086 0 0 1 5.087-5.087h9.468a5.086 5.086 0 0 1 5.087 5.087 5.085 5.085 0 0 1-5.087 5.087M358.137 266.636a5.086 5.086 0 0 1-3.597-8.684l6.697-6.696a5.085 5.085 0 0 1 7.193 0 5.085 5.085 0 0 1 0 7.193l-6.696 6.697a5.08 5.08 0 0 1-3.597 1.49"
    />
    <path
      fill="#FF8D8D"
      d="M250.101 98.774H210.43a5.02 5.02 0 0 1-5.02-5.02 5.02 5.02 0 0 1 5.02-5.02h39.671a5.02 5.02 0 0 1 5.02 5.02 5.02 5.02 0 0 1-5.02 5.02M279.552 98.774h-6.48a5.02 5.02 0 0 1-5.02-5.02 5.02 5.02 0 0 1 5.02-5.02h6.48a5.02 5.02 0 0 1 5.02 5.02 5.02 5.02 0 0 1-5.02 5.02"
    />
  </svg>
);

export const RetirementPlansIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <path
      fill="#E3A76F"
      fillRule="evenodd"
      d="M324.069 476.226h-28.23l-.055-335.436c0-25.263-20.723-45.986-45.986-45.986-25.264 0-45.987 20.722-45.987 45.986v34.815c0 7.826-6.345 14.17-14.17 14.17s-14.17-6.344-14.17-14.17V140.79c0-40.91 33.419-74.327 74.328-74.327 40.908 0 74.327 33.42 74.327 74.327z"
      clipRule="evenodd"
    />
    <path
      fill="#C48958"
      fillRule="evenodd"
      d="M309.989 476.226h-14.15l-.055-335.436c0-22.859-16.967-42-38.912-45.436a45.6 45.6 0 0 1 7.076-.55c25.263 0 45.986 20.723 45.986 45.986zM196.716 187.885c-4.241-2.449-7.095-7.031-7.095-12.28V140.79c0-38.523 29.636-70.4 67.253-73.987a75 75 0 0 0-7.075-.34c-40.909 0-74.328 33.418-74.328 74.327v34.815c0 7.826 6.344 14.17 14.17 14.17 2.577 0 4.993-.688 7.075-1.89"
      clipRule="evenodd"
    />
    <path
      fill="#C48958"
      fillRule="evenodd"
      d="M282.514 444.723h54.878c2.215 0 4.095 1.376 4.765 3.487l6.826 21.503c.498 1.569.242 3.137-.73 4.465-.972 1.329-2.388 2.047-4.035 2.047h-68.53c-1.646 0-3.063-.719-4.035-2.047s-1.228-2.896-.73-4.465l6.826-21.503c.67-2.111 2.55-3.487 4.765-3.487"
      clipRule="evenodd"
    />
    <path
      fill="#B5733E"
      fillRule="evenodd"
      d="M282.514 444.723h54.878c2.215 0 4.095 1.376 4.765 3.487l6.826 21.503c.498 1.569.242 3.137-.73 4.465-.972 1.329-2.388 2.047-4.035 2.047h-3.576l-6.36-20.034c-.67-2.111-2.551-3.487-4.765-3.487h-53.195l1.427-4.495c.67-2.11 2.55-3.486 4.765-3.486"
      clipRule="evenodd"
    />
    <path
      fill="#F6DCCD"
      fillRule="evenodd"
      d="m43.377 152.203 76.236 20.551c14.308 3.857 28.265 5.57 40.695-2.493 13.859-8.989 35.811-26.199 59.864-37.53 8.567-5.555 11.898-16.517 6.794-25.358-5.105-8.842-14.471-11.597-25.358-6.797l8.457-3.782c9.691-4.332 19.36-5.438 29.604-2.652l73.35 19.954c57.016 15.509 52.42-30.622 33.316-36.324l-134.14-40.048c-12.337-3.682-24.332-2.098-35.482 4.34L99.193 86.82l-35.714-9.569c-6.866-1.84-13.968 2.26-15.808 9.127L34.268 136.4c-1.838 6.861 2.25 13.955 9.109 15.804"
      clipRule="evenodd"
    />
    <path
      fill="#F1CBBC"
      fillRule="evenodd"
      d="M224.402 103.823c-5.373-5.947-13.533-7.332-22.794-3.249-12.711 7.283-25.382 14.653-38.07 21.979a7.106 7.106 0 0 0 7.105 12.307zM43.377 152.204l76.237 20.551c14.308 3.857 28.265 5.57 40.695-2.493 7.414-4.809 17.146-11.971 28.277-19.327L40.972 111.381l-6.704 25.02c-1.838 6.86 2.25 13.954 9.109 15.803"
      clipRule="evenodd"
    />
    <path
      fill="#D1D1D6"
      fillRule="evenodd"
      d="m55.536 171.264 27.558-106.5c1.333-5.15-1.791-10.453-6.94-11.786l-20.502-5.305c-5.149-1.333-10.453 1.79-11.785 6.94l-27.558 106.5c-1.333 5.149 1.79 10.453 6.94 11.785l20.502 5.305c5.149 1.333 10.453-1.79 11.785-6.939"
      clipRule="evenodd"
    />
    <path
      fill="#B1B1B5"
      fillRule="evenodd"
      d="m66.038 100.351 4.878-18.85 4.823-18.64c1.33-5.139-1.778-10.431-6.909-11.777l7.324 1.895c5.149 1.333 8.272 6.636 6.94 11.786l-4.84 18.703-9.718 37.555-9.729 37.597-3.272 12.644c-1.154 4.461-5.289 7.4-9.721 7.24l5.665-21.89 9.718-37.555 4.84-18.703z"
      clipRule="evenodd"
    />
    <path
      fill="#685E68"
      fillRule="evenodd"
      d="M39.87 160.65a6.58 6.58 0 1 1-1.531-13.07 6.58 6.58 0 0 1 1.531 13.07"
      clipRule="evenodd"
    />
    <path
      fill="#FFE177"
      fillRule="evenodd"
      d="M478.405 432.333H367.831c-9.676 0-17.593-7.916-17.593-17.592v-12.916c0-9.676 7.917-17.592 17.593-17.592-9.676 0-17.593-7.916-17.593-17.592v-12.916c0-9.676 7.917-17.592 17.593-17.592h110.574c9.676 0 17.592 7.916 17.592 17.592v12.916c0 9.676-7.917 17.592-17.592 17.592 9.676 0 17.592 7.916 17.592 17.592v12.916c0 9.676-7.917 17.592-17.592 17.592 9.676 0 17.592 7.916 17.592 17.592v12.916c.001 9.676-7.916 17.592-17.592 17.592"
      clipRule="evenodd"
    />
    <path
      fill="#FFD064"
      fillRule="evenodd"
      d="M478.405 432.333h-13.934c9.676 0 17.592-7.916 17.592-17.592v-12.916c0-9.676-7.917-17.592-17.592-17.592 9.676 0 17.592-7.916 17.592-17.592v-12.916c0-9.676-7.917-17.592-17.592-17.592 9.676 0 17.592-7.916 17.592-17.592v-12.916c0-9.676-7.917-17.592-17.592-17.592h13.934c9.676 0 17.592 7.916 17.592 17.592v12.916c0 9.676-7.917 17.592-17.592 17.592 9.676 0 17.592 7.916 17.592 17.592v12.916c0 9.676-7.917 17.592-17.592 17.592 9.676 0 17.592 7.916 17.592 17.592v12.916c.001 9.676-7.916 17.592-17.592 17.592"
      clipRule="evenodd"
    />
    <path
      fill="#FFD064"
      fillRule="evenodd"
      d="M478.405 336.133H367.831c-9.676 0-17.593 7.916-17.593 17.592v12.916c0 9.676 7.917 17.592 17.593 17.592h110.574c9.676 0 17.592-7.916 17.592-17.592v-12.916c.001-9.676-7.916-17.592-17.592-17.592"
      clipRule="evenodd"
    />
    <path
      fill="#FFC338"
      fillRule="evenodd"
      d="M478.405 336.133h-13.934c9.676 0 17.592 7.916 17.592 17.592v12.916c0 9.676-7.917 17.592-17.592 17.592h13.934c9.676 0 17.592-7.916 17.592-17.592v-12.916c.001-9.676-7.916-17.592-17.592-17.592"
      clipRule="evenodd"
    />
    <path
      fill="#FFC338"
      d="M495.706 229.147c1.329-40.21-30.192-73.883-70.402-75.212-40.21-1.328-73.884 30.192-75.212 70.401-1.328 40.21 30.192 73.883 70.402 75.212 40.21 1.328 73.884-30.192 75.212-70.401"
    />
    <path
      fill="#F5B829"
      fillRule="evenodd"
      d="M423.118 153.736c40.25 0 72.88 32.629 72.88 72.88s-32.629 72.88-72.88 72.88c-2.183 0-4.341-.102-6.475-.29 37.216-3.277 66.404-34.523 66.404-72.59s-29.188-69.312-66.404-72.59a74 74 0 0 1 6.475-.29"
      clipRule="evenodd"
    />
    <path
      fill="#FFF1C0"
      fillRule="evenodd"
      d="M451.949 201.382a7.999 7.999 0 0 1-14.75 6.188c-1.927-4.589-5.583-7.237-9.598-8.255a17.8 17.8 0 0 0-7.84-.193c-2.427.489-4.654 1.47-6.385 2.878-2.07 1.683-3.385 4.105-3.239 7.099.129 2.669 1.54 4.511 3.506 5.795 2.895 1.89 6.949 2.949 10.822 3.585 5.86.962 12.268 2.574 17.664 5.832 6.328 3.821 11.103 9.575 12.178 18.428q.12.999.154 2.424c.194 8.148-3.513 14.212-9.086 18.441-4.097 3.109-9.177 5.092-14.257 6.075v3.056a8 8 0 0 1-16 0v-3.215c-4.065-.897-7.934-2.474-11.323-4.73-5.648-3.762-9.976-9.315-11.807-16.662a7.98 7.98 0 1 1 15.5-3.812c.781 3.133 2.659 5.523 5.12 7.162 3.131 2.085 7.167 3.079 11.275 2.981a27 27 0 0 0 2.515-.207c3.491-.424 6.947-1.509 9.353-3.334 1.697-1.288 2.828-3.068 2.773-5.379a13 13 0 0 0-.092-.924c-.375-3.091-2.166-5.174-4.552-6.615-3.319-2.004-7.78-3.081-11.977-3.77-5.681-.933-11.861-2.64-16.947-5.96-6.014-3.926-10.335-9.741-10.756-18.42-.417-8.592 3.281-15.481 9.114-20.224 3.36-2.732 7.439-4.693 11.804-5.785V180.5a8 8 0 0 1 16 0v3.229l.358.088c8.576 2.172 16.377 7.809 20.473 17.565"
      clipRule="evenodd"
    />
    <path
      fill="#5C6BCA"
      fillRule="evenodd"
      d="m183.353 226.361 88.715 38.02v71.734c0 52.653-37.7 93.298-88.715 102.19-51.015-8.893-88.715-49.537-88.715-102.19v-71.734z"
      clipRule="evenodd"
    />
    <path
      fill="#7385F8"
      fillRule="evenodd"
      d="m183.353 226.361 88.715 38.02v71.734c0 52.653-37.7 93.298-88.715 102.19q-.427-.077-.852-.157c45.708-12.253 78.416-50.872 78.416-99.914V266.5l-85.612-36.69z"
      clipRule="evenodd"
    />
    <path
      fill="#F2EBEB"
      fillRule="evenodd"
      d="m183.353 248.121-68.715 29.449v58.547c0 41.676 28.987 73.448 68.715 81.827 39.728-8.379 68.715-40.15 68.715-81.827V277.57z"
      clipRule="evenodd"
    />
    <path
      fill="#D1D1D6"
      fillRule="evenodd"
      d="m183.353 248.121-68.715 29.449v58.547c0 41.676 28.987 73.448 68.715 81.827q.84-.178 1.672-.37c-34.617-11.189-58.938-41.049-58.938-79.222v-58.547l65.598-28.113z"
      clipRule="evenodd"
    />
    <path
      fill="#FFC338"
      d="M239.945 333.644c.812-31.221-23.84-57.188-55.06-58s-57.188 23.84-58 55.06 23.84 57.188 55.06 58 57.188-23.839 58-55.06"
    />
    <path
      fill="#F5B829"
      fillRule="evenodd"
      d="M183.353 275.803c31.221 0 56.53 25.309 56.53 56.53s-25.309 56.53-56.53 56.53c-1.63 0-3.244-.073-4.84-.209 28.954-2.455 51.69-26.731 51.69-56.321s-22.736-53.866-51.69-56.321a57 57 0 0 1 4.84-.209"
      clipRule="evenodd"
    />
    <path
      fill="#FFF1C0"
      fillRule="evenodd"
      d="M207.37 312.067a7.999 7.999 0 0 1-14.75 6.188c-1.251-2.98-3.622-4.699-6.225-5.359a12.05 12.05 0 0 0-5.296-.136c-1.601.322-3.058.96-4.174 1.867-1.184.963-1.936 2.34-1.854 4.034.068 1.396.835 2.379 1.906 3.078 1.999 1.305 4.906 2.055 7.707 2.515 4.732.777 9.921 2.088 14.339 4.755 5.351 3.231 9.389 8.105 10.301 15.619q.097.806.126 2.048c.166 6.975-2.998 12.159-7.756 15.769-3.016 2.289-6.65 3.842-10.344 4.733v.927a8 8 0 0 1-16 0v-1.094c-2.85-.774-5.559-1.966-7.976-3.576-4.738-3.156-8.37-7.818-9.909-13.99a7.98 7.98 0 0 1 5.844-9.656 7.98 7.98 0 0 1 9.656 5.844c.488 1.958 1.67 3.457 3.221 4.49 2.121 1.413 4.884 2.085 7.715 2.018q.64-.015 1.782-.153c2.428-.294 4.795-1.022 6.386-2.229.882-.669 1.47-1.57 1.443-2.707l-.064-.548c-.212-1.751-1.266-2.956-2.676-3.806-2.341-1.413-5.583-2.189-8.652-2.693-4.609-.757-9.641-2.154-13.832-4.89-5.119-3.342-8.797-8.297-9.156-15.703-.354-7.293 2.782-13.138 7.729-17.16 2.456-1.997 5.367-3.5 8.49-4.455v-1.236a8 8 0 0 1 16 0v1.133c6.735 2.003 12.772 6.638 16.019 14.373"
      clipRule="evenodd"
    />
  </svg>
);

export const DisabilityInsuranceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <g clipPath="url(#a)">
      <path
        fill="#3692BC"
        d="M328.774 443.182h-50.583a7.7 7.7 0 0 1-7.702-7.702 7.7 7.7 0 0 1 7.702-7.702h50.583a7.14 7.14 0 0 0 5.34-2.403l27.837-31.413a7.706 7.706 0 0 1 10.874-.656 7.704 7.704 0 0 1 .656 10.874l-27.837 31.412a22.56 22.56 0 0 1-16.87 7.59"
      />
      <path
        fill="#D8ECFE"
        d="M278.191 480.217a7.7 7.7 0 0 1-7.702-7.702v-90.938a7.7 7.7 0 0 1 7.702-7.702 7.7 7.7 0 0 1 7.702 7.702v90.938a7.7 7.7 0 0 1-7.702 7.702"
      />
      <path
        fill="#3692BC"
        d="M303.801 489.13c1.404-14.109-8.896-26.684-23.004-28.088s-26.684 8.896-28.087 23.004c-1.404 14.109 8.895 26.684 23.004 28.088 14.108 1.403 26.683-8.896 28.087-23.004"
      />
      <path
        fill="#FE93BB"
        d="M386.214 38.816c-34.762 0-66.579-12.598-91.144-33.472-8.386-7.126-20.743-7.126-29.128 0-24.565 20.874-56.382 33.472-91.144 33.472-3.588 0-7.145-.136-10.666-.4-7.975-.598-15.032 5.254-15.746 13.22a221 221 0 0 0-.883 19.764c0 86.649 50.219 161.561 123.136 197.241a22.49 22.49 0 0 0 19.736 0c72.917-35.68 123.135-110.592 123.135-197.24 0-6.662-.299-13.254-.883-19.764-.714-7.967-7.771-13.818-15.746-13.22q-5.284.397-10.667.398"
      />
      <path
        fill="#FE76A8"
        d="M412.626 51.636c-.714-7.966-7.771-13.818-15.746-13.219q-5.283.399-10.666.4c-1.809 0-3.608-.043-5.4-.11 3.377 2.404 5.731 6.186 6.129 10.626.59 6.58.892 13.24.892 19.972 0 86.128-49.102 160.779-120.835 197.511q1.81.928 3.638 1.825a22.48 22.48 0 0 0 19.736 0c72.917-35.68 123.135-110.592 123.135-197.24 0-6.663-.299-13.255-.883-19.765"
      />
      <path
        fill="#D8ECFE"
        d="M327.968 107.284h-25.554a5.164 5.164 0 0 1-5.165-5.165V76.565a5.164 5.164 0 0 0-5.165-5.165h-23.156a5.164 5.164 0 0 0-5.165 5.165v25.554a5.164 5.164 0 0 1-5.165 5.165h-25.554a5.164 5.164 0 0 0-5.165 5.165v23.156a5.164 5.164 0 0 0 5.165 5.165h25.554a5.164 5.164 0 0 1 5.165 5.165v25.554a5.164 5.164 0 0 0 5.165 5.165h23.156a5.164 5.164 0 0 0 5.165-5.165v-25.554a5.164 5.164 0 0 1 5.165-5.165h25.554a5.164 5.164 0 0 0 5.165-5.165v-23.156a5.164 5.164 0 0 0-5.165-5.165"
      />
      <path
        fill="#00F2A6"
        d="M467.812 225.881H329.127l-42.253 45.48v87.349c0 5.943 4.818 10.762 10.762 10.762h170.177l42.253-45.48v-52.631z"
      />
      <path fill="#0ED290" d="M486.445 258.984v73.68l23.62-8.673V271.36z" />
      <path
        fill="#3692BC"
        d="m408.043 290.903-2.823-1.004c-7.412-2.636-11.133-3.957-14.551-5.756-1.229-.646-1.776-1.721-1.628-3.194.196-1.934 1.691-4.375 5.303-5.426 9.116-2.655 17.502 3.751 17.73 3.929a7.705 7.705 0 0 0 10.795-1.156 7.7 7.7 0 0 0-1.124-10.834c-.387-.314-6.563-5.233-15.569-7.194v-4.763a7.7 7.7 0 0 0-7.702-7.702 7.7 7.7 0 0 0-7.702 7.702v5.035c-.244.065-.487.121-.732.193-9.038 2.631-15.447 9.959-16.325 18.669-.782 7.748 2.967 14.789 9.782 18.375 4.394 2.311 8.716 3.847 16.564 6.637l2.81.999c2.153.767 9.116 3.618 8.342 8.096-.58 3.353-5.042 6.972-11.241 6.972-6.38 0-12.509-2.472-16.394-6.612a7.704 7.704 0 0 0-11.235 10.541c4.834 5.152 11.282 8.743 18.427 10.412v5.023a7.7 7.7 0 0 0 7.702 7.702 7.7 7.7 0 0 0 7.702-7.702v-4.627c10.341-2.182 18.586-9.652 20.217-19.086 1.473-8.512-2.576-19.609-18.348-25.229"
      />
      <path
        fill="#FEDF30"
        d="M504.341 323.557c-20.705 0-37.49 16.785-37.49 37.49 0 2.898.34 5.715.962 8.425h31.491c5.944 0 10.762-4.818 10.762-10.762v-34.718a38 38 0 0 0-5.725-.435M467.812 225.88a37.6 37.6 0 0 0-.962 8.424c0 20.706 16.785 37.491 37.49 37.491 1.947 0 3.858-.149 5.725-.435v-34.719c0-5.944-4.818-10.762-10.762-10.762h-31.491z"
      />
      <path
        fill="#FAC600"
        d="M510.065 358.71v-34.718a38 38 0 0 0-5.725-.435 37.3 37.3 0 0 0-17.896 4.54v30.613c0 5.943-4.818 10.762-10.762 10.762h23.62c5.945 0 10.763-4.818 10.763-10.762M504.341 271.795c1.946 0 3.858-.149 5.725-.435v-34.719c0-5.943-4.818-10.762-10.762-10.762h-23.619c5.943.001 10.76 4.819 10.76 10.762v30.614a37.3 37.3 0 0 0 17.896 4.54"
      />
      <path
        fill="#FEDF30"
        d="M292.599 323.557c20.705 0 37.49 16.785 37.49 37.49 0 2.898-.34 5.715-.962 8.425h-31.491c-5.944 0-10.762-4.818-10.762-10.762v-34.718a38 38 0 0 1 5.725-.435M329.127 225.881c.622 2.709.962 5.526.962 8.424 0 20.706-16.785 37.491-37.49 37.491-1.947 0-3.858-.149-5.725-.435v-34.718c0-5.944 4.818-10.762 10.762-10.762z"
      />
      <path
        fill="#FD9468"
        d="M108.863 190.307v90.867h35.759v-71.069c0-10.934-8.864-19.798-19.798-19.798z"
      />
      <path
        fill="#62DBFB"
        d="M291.197 262.768H108.863v53.221c44.373 0 81.005 33.041 86.697 75.857h95.638a9.29 9.29 0 0 0 9.292-9.292V272.06c0-5.132-4.161-9.292-9.293-9.292"
      />
      <path
        fill="#01C0FA"
        d="M291.197 262.768h-25.674a9.29 9.29 0 0 1 9.292 9.292v110.494a9.29 9.29 0 0 1-9.292 9.292h25.674a9.29 9.29 0 0 0 9.292-9.292V272.06c.001-5.132-4.16-9.292-9.292-9.292"
      />
      <path
        fill="#D8ECFE"
        d="M108.863 318.801a7.7 7.7 0 0 1-7.702-7.702V183.806c0-4.409-3.587-7.996-7.996-7.996H57.127a7.7 7.7 0 0 1-7.702-7.702 7.7 7.7 0 0 1 7.702-7.702h36.037c12.903 0 23.401 10.497 23.401 23.401V311.1a7.7 7.7 0 0 1-7.702 7.701"
      />
      <path
        fill="#B3DAFE"
        d="M108.863 392.265a7.7 7.7 0 0 1-7.702-7.702v-54.199a7.7 7.7 0 0 1 7.702-7.702 7.7 7.7 0 0 1 7.702 7.702v54.199a7.7 7.7 0 0 1-7.702 7.702M92.473 401.725a7.67 7.67 0 0 1-3.844-1.033l-46.938-27.1a7.7 7.7 0 0 1-2.819-10.521 7.7 7.7 0 0 1 10.521-2.819l46.938 27.1a7.702 7.702 0 0 1-3.858 14.373M45.549 447.739a7.702 7.702 0 0 1-3.858-14.372l46.938-27.102a7.702 7.702 0 0 1 7.702 13.34l-46.938 27.102a7.67 7.67 0 0 1-3.844 1.032M108.863 484.296a7.7 7.7 0 0 1-7.702-7.702v-54.199a7.7 7.7 0 0 1 7.702-7.702 7.7 7.7 0 0 1 7.702 7.702v54.199a7.7 7.7 0 0 1-7.702 7.702M172.176 447.74a7.67 7.67 0 0 1-3.844-1.033l-46.939-27.101a7.7 7.7 0 0 1-2.819-10.521 7.7 7.7 0 0 1 10.521-2.819l46.939 27.101a7.702 7.702 0 0 1-3.858 14.373M125.251 401.724a7.702 7.702 0 0 1-3.858-14.373l46.939-27.1a7.702 7.702 0 1 1 7.702 13.34l-46.939 27.1a7.67 7.67 0 0 1-3.844 1.033"
      />
      <path
        fill="#FE93BB"
        d="M108.863 424.019c11.344 0 20.54-9.196 20.54-20.54s-9.196-20.54-20.54-20.54-20.54 9.197-20.54 20.54 9.196 20.54 20.54 20.54"
      />
      <path
        fill="#3692BC"
        d="M108.863 296.551c-58.96 0-106.928 47.968-106.928 106.927 0 58.961 47.968 106.929 106.928 106.929s106.928-47.968 106.928-106.929c0-58.959-47.968-106.927-106.928-106.927m0 180.043c-40.38 0-73.116-32.735-73.116-73.116s32.735-73.116 73.116-73.116 73.116 32.735 73.116 73.116-32.735 73.116-73.116 73.116"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h512v512H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const BonusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <g clipPath="url(#a)">
      <path
        fill="#D83131"
        d="m98.528 357.248-45.005 77.951c-7.032 12.179 2.859 27.16 16.822 25.477l44.478-5.359a8.53 8.53 0 0 1 8.868 5.12l17.598 41.199c5.525 12.933 23.443 14.009 30.475 1.829l46.285-80.167h75.902l46.285 80.167c7.032 12.179 24.95 11.104 30.475-1.829l17.598-41.199a8.53 8.53 0 0 1 8.868-5.12l44.478 5.359c13.963 1.682 23.853-13.298 16.822-25.477l-45.005-77.951z"
      />
      <path
        fill="#C41926"
        d="m458.477 435.199-45.005-77.951h-22.024l43.335 75.059c7.032 12.18-2.859 27.16-16.822 25.477l-44.478-5.358a8.53 8.53 0 0 0-8.868 5.12l-17.598 41.199c-1.236 2.895-3.096 5.19-5.314 6.881 7.793 9.833 23.834 8.122 29.008-3.989l17.598-41.199a8.53 8.53 0 0 1 8.868-5.12l44.478 5.359c13.963 1.682 23.854-13.298 16.822-25.478M270.257 420.408l-74.624-2.402-47.563 82.569a17.1 17.1 0 0 1-4.408 5.05c7.141 9.01 21.88 8.618 28.102-2.158l46.285-80.167h53.878z"
      />
      <path
        fill="#FE950D"
        d="m326.44 412.356 87.018-55.099c19.763-21.61 35.144-47.295 44.717-75.657V145.067C429.707 60.727 349.946 0 256 0S82.293 60.727 53.825 145.067V281.6C82.293 365.94 162.054 426.667 256 426.667c12.962 0 25.651-1.162 37.975-3.376z"
      />
      <path
        fill="#FA6F0C"
        d="M256 0c-3.976 0-7.925.118-11.847.333 88.756 4.859 163.065 63.964 190.328 144.734V281.6c-27.263 80.77-101.572 139.875-190.328 144.734 3.923.215 7.871.333 11.847.333 93.946 0 173.707-60.727 202.175-145.067V145.067C429.707 60.727 349.946 0 256 0"
      />
      <path
        fill="#FEDF30"
        d="M403.091 281.599c-25.77 55.43-81.937 93.867-147.091 93.867s-121.321-38.437-147.091-93.867V145.066c25.77-55.43 81.937-93.867 147.091-93.867s121.321 38.437 147.091 93.867z"
      />
      <path
        fill="#D83131"
        d="M494.902 281.6H17.098c-14.064 0-22.092-16.056-13.653-27.307l26.88-35.84a8.535 8.535 0 0 0 0-10.24l-26.88-35.84c-8.438-11.251-.41-27.307 13.653-27.307h477.805c14.064 0 22.092 16.056 13.653 27.307l-26.88 35.84a8.53 8.53 0 0 0 0 10.24l26.88 35.84c8.438 11.251.41 27.307-13.654 27.307"
      />
      <path
        fill="#FEDF30"
        d="M286.685 171.473h-.076a7.726 7.726 0 0 0-7.651 7.801l.428 44.236-33.544-48.574a7.726 7.726 0 0 0-14.084 4.39v68.139a7.726 7.726 0 1 0 15.452 0v-43.354l31.99 46.324c2.303 3.326 6.133 4.746 9.752 3.613 3.703-1.157 6.096-4.644 6.095-8.957l-.638-65.967a7.725 7.725 0 0 0-7.724-7.651M100.366 208.245a23.3 23.3 0 0 0 4.181-13.337c0-12.922-10.513-23.435-23.435-23.435h-19.83a7.726 7.726 0 0 0-7.725 7.726v68.267a7.725 7.725 0 0 0 7.726 7.726h.034c.002 0 18.233-.08 23.259-.08 14.392 0 26.102-11.709 26.102-26.102-.001-8.461-4.052-15.992-10.312-20.765m-19.254-21.319c4.4 0 7.982 3.581 7.982 7.982s-3.58 7.982-7.982 7.982c-1.478 0-4.28.008-7.321.019h-4.782v-15.983zm3.464 52.734c-2.852 0-9.945.026-15.566.048V218.38l4.752-.018h10.815c5.872 0 10.649 4.777 10.649 10.649-.002 5.872-4.78 10.649-10.65 10.649M438.778 206.622c-8.512-3.141-16.426-6.562-18.722-7.568-1.592-1.242-2.356-3.171-2.056-5.257.195-1.358 1.169-4.674 5.996-6.128 10.061-3.033 19.299 4.304 19.531 4.492a7.727 7.727 0 0 0 9.907-11.859c-.631-.531-15.659-12.918-33.896-7.43-9.12 2.749-15.571 9.924-16.835 18.728-1.183 8.242 2.388 16.169 9.32 20.688q.513.335 1.072.585c.394.176 9.771 4.349 20.334 8.247 3.184 1.174 10.478 4.517 9.465 10.191-.739 4.143-5.7 8.428-12.72 8.428-7.01 0-13.763-2.834-18.064-7.581a7.727 7.727 0 0 0-11.451 10.376c7.182 7.926 18.216 12.657 29.515 12.657 13.995 0 25.742-8.9 27.932-21.164 1.643-9.195-2.572-21.225-19.328-27.405M372.253 171.473a7.726 7.726 0 0 0-7.726 7.726v46.926c0 3.502-.979 8.015-8.615 11.86-2.312 1.164-4.924 1.755-7.764 1.755h-.028c-3.172-.004-5.931-.784-8.434-2.383-5.928-3.788-7.143-7.209-7.143-11.182V179.2a7.726 7.726 0 1 0-15.452 0v46.975c0 10.15 4.669 18.066 14.276 24.204 4.987 3.186 10.617 4.806 16.732 4.814h.049c5.275 0 10.225-1.146 14.713-3.405 14.147-7.124 17.117-17.887 17.117-25.662V179.2a7.725 7.725 0 0 0-7.725-7.727M171.217 171.473c-23.081 0-41.86 18.779-41.86 41.86s18.778 41.859 41.86 41.859 41.86-18.778 41.86-41.859-18.778-41.86-41.86-41.86m0 68.267c-14.561 0-26.407-11.846-26.407-26.406 0-14.561 11.846-26.407 26.407-26.407s26.407 11.846 26.407 26.407-11.846 26.406-26.407 26.406"
      />
      <path
        fill="#C41926"
        d="M481.676 218.453a8.53 8.53 0 0 1 0-10.24l26.88-35.84c8.438-11.251.41-27.307-13.653-27.307h-23.694c14.064 0 22.091 16.056 13.653 27.307l-26.88 35.84a8.53 8.53 0 0 0 0 10.24l26.88 35.84c8.438 11.251.41 27.307-13.653 27.307h23.694c14.064 0 22.091-16.056 13.653-27.307z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h512v512H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const EquityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <path
      fill="#F55059"
      fillRule="evenodd"
      d="M194.663 148.253 166.117 280.68l35.055 130.827c-72.254 19.36-146.522-23.518-165.882-95.772s23.518-146.522 95.772-165.882c21.523-5.767 43.225-6.01 63.601-1.6"
      clipRule="evenodd"
    />
    <path
      fill="#4AA8F2"
      fillRule="evenodd"
      d="m322.916 199.355-108.187 81.547 109.888 53.829 11.747 5.754c13.914-28.374 18.014-61.715 9.193-94.638-4.647-17.341-12.457-32.99-22.641-46.492"
      clipRule="evenodd"
    />
    <path
      fill="#FED821"
      fillRule="evenodd"
      d="M307.135 180.599c-19.611-25.999-48.03-44.041-79.641-50.882l-28.546 132.428z"
      clipRule="evenodd"
    />
    <path
      fill="#37D48D"
      fillRule="evenodd"
      d="m306.704 354.645-109.888-53.829 35.055 130.827c39.331-10.539 69.957-37.347 86.579-71.244z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M115.907 273.681a24.12 24.12 0 0 1 17.103 7.087 24.1 24.1 0 0 1 7.082 17.098 24.12 24.12 0 0 1-7.084 17.101 24.1 24.1 0 0 1-17.101 7.084 24.11 24.11 0 0 1-17.101-7.084 24.11 24.11 0 0 1-7.084-17.101 7 7 0 1 1 14 0c0 2.813 1.14 5.36 2.982 7.203a10.15 10.15 0 0 0 7.202 2.982c2.813 0 5.36-1.14 7.203-2.982a10.15 10.15 0 0 0 2.982-7.203c0-2.816-1.14-5.36-2.98-7.2a10.16 10.16 0 0 0-7.205-2.985 24.12 24.12 0 0 1-17.104-7.087 24.1 24.1 0 0 1-7.081-17.098 24.12 24.12 0 0 1 7.084-17.101 24.11 24.11 0 0 1 17.101-7.084 24.11 24.11 0 0 1 17.101 7.084 24.11 24.11 0 0 1 7.084 17.101 7 7 0 1 1-14 0c0-2.813-1.14-5.36-2.982-7.203a10.16 10.16 0 0 0-7.203-2.982c-2.814 0-5.36 1.14-7.202 2.982a10.15 10.15 0 0 0-2.982 7.203c0 2.817 1.14 5.36 2.979 7.199a10.16 10.16 0 0 0 7.206 2.986"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M108.907 235.078a7 7 0 1 1 14 0v10.237a7 7 0 1 1-14 0zm0 80.968a7 7 0 1 1 14 0v10.237a7 7 0 1 1-14 0z"
      clipRule="evenodd"
    />
    <path
      fill="#FED821"
      d="M337.863 56.462c12.554 0 22.731-10.177 22.731-22.731S350.417 11 337.863 11s-22.731 10.177-22.731 22.731 10.177 22.731 22.731 22.731"
    />
    <path
      fill="#FED821"
      fillRule="evenodd"
      d="M337.863 69.389c28.554 0 51.702 23.148 51.702 51.702H286.16c0-28.554 23.148-51.702 51.703-51.702"
      clipRule="evenodd"
    />
    <path
      fill="#4AA8F2"
      d="M445.657 246.713c8.876-8.875 8.876-23.266 0-32.141s-23.266-8.876-32.142 0c-8.875 8.875-8.875 23.266 0 32.141s23.266 8.876 32.142 0"
    />
    <path
      fill="#4AA8F2"
      fillRule="evenodd"
      d="M429.656 266.279c28.555 0 51.702 23.148 51.702 51.702H377.954c0-28.554 23.148-51.702 51.702-51.702"
      clipRule="evenodd"
    />
    <path
      fill="#37D48D"
      d="M341.481 436.372c12.554 0 22.731-10.177 22.731-22.731s-10.177-22.731-22.731-22.731-22.731 10.177-22.731 22.731 10.177 22.731 22.731 22.731"
    />
    <path
      fill="#37D48D"
      fillRule="evenodd"
      d="M341.481 449.299c28.554 0 51.702 23.148 51.702 51.702H289.779c0-28.554 23.148-51.702 51.702-51.702"
      clipRule="evenodd"
    />
  </svg>
);

export const FlexibleWorkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <path
      fill="#FCDB35"
      d="M429.34 234.453c38.28-38.28 38.28-100.344 0-138.624s-100.344-38.28-138.624 0-38.28 100.344 0 138.624 100.344 38.28 138.624 0"
    />
    <path
      fill="#FFEB87"
      d="M422.33 227.442c34.408-34.408 34.408-90.195 0-124.603s-90.195-34.408-124.603 0-34.408 90.195 0 124.603 90.195 34.408 124.603 0"
    />
    <path
      fill="#7986BF"
      fillRule="evenodd"
      d="M414.441 290.276a6.983 6.983 0 1 1-6.398-12.414l11.704-6.044a6.983 6.983 0 1 1 6.398 12.414zm-6.398-237.899a6.983 6.983 0 1 1 6.398-12.414l11.704 6.044a6.983 6.983 0 1 1-6.398 12.414zm38.739 24.819a6.972 6.972 0 0 1 10.391-9.297l8.778 9.821a6.972 6.972 0 0 1-10.391 9.297zm27.308 37.012a6.993 6.993 0 0 1 13.07-4.976l4.698 12.306a6.993 6.993 0 0 1-13.07 4.976zm12.327 44.325a7 7 0 1 1 14 0v13.172a7 7 0 1 1-14 0zm.743 62.474a6.993 6.993 0 0 1-13.07-4.976l4.698-12.306a6.993 6.993 0 0 1 13.07 4.976zm-29.987 41.332a6.972 6.972 0 0 1-10.391-9.297l8.778-9.821a6.972 6.972 0 0 1 10.391 9.297z"
      clipRule="evenodd"
    />
    <path
      fill="#2A92FA"
      fillRule="evenodd"
      d="M140.084 349.242c67.311 0 122.575 51.542 128.5 117.311h-257c5.925-65.769 61.189-117.311 128.5-117.311"
      clipRule="evenodd"
    />
    <path
      fill="#4EB1FC"
      fillRule="evenodd"
      d="M232.79 466.553H11.584c5.568-61.806 54.709-111.044 116.473-116.754 55.148 10.569 98.037 57.843 104.733 116.754"
      clipRule="evenodd"
    />
    <path
      fill="#FDB0A0"
      d="M140.084 348.826c33.94 0 61.453-27.514 61.453-61.453s-27.513-61.453-61.453-61.453-61.453 27.513-61.453 61.453 27.513 61.453 61.453 61.453"
    />
    <path
      fill="#FFCEC0"
      fillRule="evenodd"
      d="M127.643 347.566c-27.976-5.752-49.012-30.515-49.012-60.193s21.037-54.441 49.012-60.193c27.976 5.752 49.014 30.516 49.014 60.193s-21.038 54.441-49.014 60.193"
      clipRule="evenodd"
    />
    <path
      fill="#E68207"
      fillRule="evenodd"
      d="M297.38 112.313a7 7 0 0 1 9.898-9.898l2.385 2.385a7 7 0 0 1-9.898 9.898zm55.704-28.872a7 7 0 1 1 14 0v3.373a7 7 0 1 1-14 0zm59.806 18.974a7 7 0 0 1 9.898 9.898l-2.385 2.385a7 7 0 0 1-9.898-9.898zm28.872 55.704a7 7 0 1 1 0 14h-3.373a7 7 0 1 1 0-14zm-18.974 59.805a7 7 0 0 1-9.898 9.898l-2.385-2.385a7 7 0 0 1 9.898-9.898zm-55.704 28.872a7 7 0 1 1-14 0v-3.373a7 7 0 1 1 14 0zm-59.806-18.974a7 7 0 0 1-9.898-9.898l2.385-2.385a7 7 0 0 1 9.898 9.898zm-28.871-55.704a7 7 0 1 1 0-14h3.373a7 7 0 1 1 0 14zM353.084 119.689a7 7 0 1 1 14 0v45.43a6.98 6.98 0 0 1-2.098 4.997l-28.54 28.539a7 7 0 0 1-9.898-9.898l26.537-26.536z"
      clipRule="evenodd"
    />
    <path
      fill="#F9AC00"
      fillRule="evenodd"
      d="m266.863 392.067 24.734-24.734 7.012-.398 67.893-67.894 22.628 3.799 3.799 22.628-11.919 11.919-16.548-5.394 5.394 16.548-5.521 5.52-16.548-5.394 5.394 16.548-28.146 28.146-.399 7.013-24.734 24.734c7.449 19.997 3.139 43.379-12.936 59.454-21.97 21.97-57.59 21.97-79.559 0-21.97-21.97-21.97-57.59 0-79.559 16.075-16.075 39.458-20.386 59.455-12.936z"
      clipRule="evenodd"
    />
    <path
      fill="#FCDB35"
      fillRule="evenodd"
      d="m266.863 392.066 8.116-8.116 16.619-16.619 7.012-.398 8.116-8.116 59.778-59.778 22.628 3.799 3.799 22.629-3.803 3.803-16.548-5.394-8.116 8.116 4.139 12.698-12.698-4.139-8.116 8.116 5.394 16.548-20.03 20.03-8.116 8.116-.399 7.012-16.619 16.619-8.116 8.116c6.816 18.296 3.784 39.425-9.093 55.2-22.096 18.023-54.69 16.736-75.287-3.861s-21.884-53.191-3.861-75.288c15.775-12.877 36.904-15.908 55.2-9.092z"
      clipRule="evenodd"
    />
    <path
      fill="#FDC72E"
      fillRule="evenodd"
      d="m389.776 306.68 3.154 18.788-3.803 3.803-16.548-5.394zm-25.313 25.312 4.139 12.698-12.698-4.139zm-16.674 16.675 5.394 16.548-20.03 20.03-8.116 8.116-.399 7.012-16.619 16.619-8.116 8.116c6.816 18.296 3.784 39.425-9.093 55.2-21.288 17.364-52.319 16.801-72.98-1.683l129.958-129.957z"
      clipRule="evenodd"
    />
    <path
      fill="#F9AC00"
      fillRule="evenodd"
      d="m247.493 467.178 5.575-5.575c6.269-6.268 6.268-16.432 0-22.7s-16.431-6.269-22.7 0l-5.575 5.575z"
      clipRule="evenodd"
    />
    <path
      fill="#F3F3FF"
      fillRule="evenodd"
      d="M224.793 444.477c-6.269 6.268-6.269 16.432 0 22.7s16.432 6.268 22.7 0 6.268-16.432 0-22.7c-6.269-6.269-16.432-6.269-22.7 0"
      clipRule="evenodd"
    />
    <path
      fill="#5D689E"
      fillRule="evenodd"
      d="M236.084 90.977 216.78 87.17l-8.478-20.437 10.967-16.353-22.605-22.604-16.353 10.966-20.437-8.478-3.806-19.304H124.1l-3.806 19.304-20.438 8.478-16.352-10.966L60.9 50.38l10.965 16.353-8.477 20.437-19.304 3.806v31.968l19.304 3.806 8.477 20.437L60.9 163.541l22.604 22.604 16.352-10.966 20.438 8.478 3.806 19.304h31.968l3.806-19.304 20.437-8.478 16.353 10.966 22.605-22.604-10.967-16.353 8.478-20.437 19.304-3.806z"
      clipRule="evenodd"
    />
    <path
      fill="#7986BF"
      fillRule="evenodd"
      d="m226.752 122.945-19.304 3.806-8.478 20.437 10.967 16.353-18.859 18.858-14.333-9.611-26.203 10.869-3.806 19.304H124.1l-3.806-19.304-26.203-10.869-14.333 9.611L60.9 163.541l10.965-16.353-8.477-20.437-19.304-3.806V90.977l19.304-3.806 8.477-20.437L60.9 50.38l18.858-18.858 14.333 9.61 26.203-10.868L124.1 10.96h22.636l3.806 19.304 26.203 10.869 14.333-9.611 18.859 18.858-10.967 16.353 8.478 20.437 19.304 3.806z"
      clipRule="evenodd"
    />
    <path
      fill="#5D689E"
      d="M143.632 154.954c26.538-6.274 42.966-32.872 36.693-59.41-6.273-26.539-32.872-42.967-59.41-36.694-26.538 6.274-42.966 32.872-36.693 59.411 6.273 26.538 32.872 42.966 59.41 36.693"
    />
    <path
      fill="#F3F3FF"
      d="M147.923 155.524c26.812-4.346 45.024-29.605 40.677-56.417-4.346-26.812-29.605-45.024-56.417-40.678s-45.024 29.605-40.678 56.417 29.605 45.024 56.418 40.678"
    />
  </svg>
);

export const TuitionAssistanceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <g clipPath="url(#a)">
      <path
        fill="#FFB229"
        fillRule="evenodd"
        d="M453.053 272.468v-79.395l16.472-13.393L486 193.146v79.395l-16.475-13.466z"
        clipRule="evenodd"
      />
      <path
        fill="#8192A5"
        fillRule="evenodd"
        d="m137.503 196.033 137.815 28.16 137.817-28.16V102.66l-137.817 39.966-137.815-39.749z"
        clipRule="evenodd"
      />
      <path
        fill="#FFB229"
        d="M218.508 424.228c44.047-44.046 44.047-115.46 0-159.507s-115.461-44.047-159.507 0-44.047 115.461 0 159.507 115.461 44.047 159.507 0"
      />
      <path
        fill="#FFF1C0"
        fillRule="evenodd"
        d="M174.035 325.329a8 8 0 1 1-16 0c0-2.537-1.746-5.035-4.569-7.022a28 28 0 0 0-29.319 0c-2.823 1.987-4.569 4.485-4.569 7.022 0 7.8 10.271 9.545 20.541 11.292 16.958 2.884 33.916 5.768 33.916 27.042 0 8.048-4.35 15.135-11.381 20.084a39.6 39.6 0 0 1-15.848 6.385v8.359a8 8 0 1 1-16 0v-8.359a39.64 39.64 0 0 1-15.847-6.384c-7.031-4.951-11.381-12.037-11.381-20.085a8 8 0 1 1 16 0c0 2.537 1.746 5.035 4.569 7.022a28 28 0 0 0 29.319 0c2.823-1.987 4.569-4.485 4.569-7.022 0-7.8-10.271-9.546-20.541-11.292-16.957-2.884-33.916-5.768-33.916-27.042 0-8.048 4.35-15.134 11.381-20.085a39.64 39.64 0 0 1 15.847-6.384v-8.36a8 8 0 1 1 16 0v8.359a39.6 39.6 0 0 1 15.848 6.385c7.031 4.95 11.381 12.036 11.381 20.085"
        clipRule="evenodd"
      />
      <path
        fill="#C6CBD3"
        fillRule="evenodd"
        d="M477.5 86.562v93.117a7.97 7.97 0 0 1-15.938 0V96.917l-184.027 53.357a7.9 7.9 0 0 1-4.4.008L79.277 94.369a7.978 7.978 0 0 1-.384-15.414l194.123-56.6a7.94 7.94 0 0 1 4.521-.025l194.133 56.3a7.97 7.97 0 0 1 5.83 7.932"
        clipRule="evenodd"
      />
      <path
        fill="#8AC9FE"
        fillRule="evenodd"
        d="M319.293 301.544h-37.522L352.7 178.689l70.93 122.855h-37.888a245.76 245.76 0 0 1-207.41 188.441 236.43 236.43 0 0 0 95.593-75.435 236.4 236.4 0 0 0 45.368-113.006"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h512v512H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const CompanyDevicesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <path fill="#7488ED" d="M214.793 331.775h82.414v51.973h-82.414z" />
    <path fill="#6073D1" d="M266.302 331.775h30.905v51.973h-30.905z" />
    <path
      fill="#FF3D7A"
      d="M323.992 376.246H188.008a7.5 7.5 0 0 0 0 15h135.984a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5"
    />
    <path
      fill="#8C9EFF"
      d="M432.99 338.418H86.221c-11.205 0-20.289-9.084-20.289-20.289V88.789c0-11.205 9.084-20.289 20.289-20.289h346.77c11.205 0 20.289 9.084 20.289 20.289v229.339c0 11.206-9.084 20.29-20.29 20.29"
    />
    <path
      fill="#7488ED"
      d="M432.991 68.5h-30.905c11.205 0 20.289 9.084 20.289 20.29v229.338c0 11.206-9.084 20.29-20.289 20.29h30.905c11.205 0 20.289-9.084 20.289-20.29V88.79c0-11.206-9.084-20.29-20.289-20.29"
    />
    <path
      fill="#fff"
      d="M96.837 304.51V102.406a3 3 0 0 1 3-3h319.537a3 3 0 0 1 3 3V304.51a3 3 0 0 1-3 3H99.837a3 3 0 0 1-3-3"
    />
    <path
      fill="#FFCA28"
      d="M153.572 443.5H13.318C5.963 443.5 0 437.537 0 430.182V186.9c0-7.355 5.963-13.318 13.318-13.318h140.254c7.355 0 13.318 5.963 13.318 13.318v243.282c-.001 7.355-5.963 13.318-13.318 13.318"
    />
    <path
      fill="#FFB300"
      d="M153.572 173.582h-30.905c7.355 0 13.317 5.963 13.317 13.318v243.282c0 7.355-5.963 13.318-13.317 13.318h30.905c7.355 0 13.317-5.963 13.317-13.318V186.9c0-7.355-5.962-13.318-13.317-13.318"
    />
    <path
      fill="#FF3D7A"
      d="M503.758 423.559h-96.837a8.24 8.24 0 0 1-8.242-8.242V238.119a8.24 8.24 0 0 1 8.242-8.242h96.837a8.24 8.24 0 0 1 8.242 8.242v177.198a8.24 8.24 0 0 1-8.242 8.242"
    />
    <path
      fill="#EB3870"
      d="M503.759 229.879h-30.905a8.24 8.24 0 0 1 8.241 8.242v177.198a8.24 8.24 0 0 1-8.241 8.242h30.905a8.24 8.24 0 0 0 8.241-8.242V238.12a8.24 8.24 0 0 0-8.241-8.241"
    />
    <path
      fill="#FFCA28"
      d="M282.785 193.158h-53.569a4.12 4.12 0 0 1-4.121-4.121v-53.572a4.12 4.12 0 0 1 4.121-4.121h53.569a4.12 4.12 0 0 1 4.121 4.121v53.572a4.12 4.12 0 0 1-4.121 4.121"
    />
    <path
      fill="#FF3D7A"
      d="M194.189 234.139h123.622a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5H194.189a7.5 7.5 0 0 0 0 15M317.811 252.105H194.189a7.5 7.5 0 0 0 0 15h123.622a7.5 7.5 0 0 0 0-15M127.047 272.921h-20.995a7.5 7.5 0 0 0-7.002 4.813l-6.128 15.976-6.576-53.632a7.5 7.5 0 0 0-14.413-1.86l-14.415 36.236H40.459a7.5 7.5 0 0 0 0 15h22.146a7.5 7.5 0 0 0 6.969-4.728l5.453-13.707 6.669 54.397a7.5 7.5 0 0 0 14.447 1.774l15.065-39.27h15.839a7.5 7.5 0 0 0 0-14.999"
    />
    <path
      fill="#8C9EFF"
      d="M109.199 403.807h-51.51a7.5 7.5 0 0 0 0 15h51.51a7.5 7.5 0 0 0 0-15"
    />
    <path
      fill="#BDF9FF"
      d="M465.127 246.439h-20.604a7.5 7.5 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h20.604a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5"
    />
  </svg>
);

export const CommuterBenefitIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <g clipPath="url(#a)">
      <path
        fill="#7986BF"
        fillRule="evenodd"
        d="M88.688 97.057H39.855a11.84 11.84 0 0 0-8.391 3.492 11.84 11.84 0 0 0-3.492 8.391v22.286H10.99V108.94c0-7.953 3.242-15.17 8.467-20.398 5.226-5.226 12.445-8.468 20.398-8.468h48.833zM428.158 80.074h43.99c7.953 0 15.173 3.242 20.398 8.468 5.228 5.225 8.468 12.445 8.468 20.398v19.994h-16.983V108.94c0-3.266-1.337-6.236-3.492-8.391a11.84 11.84 0 0 0-8.391-3.492h-43.99z"
        clipRule="evenodd"
      />
      <path
        fill="#3D4A75"
        fillRule="evenodd"
        d="M98.023 374.615h68.757v102.848c0 9.696-7.935 17.63-17.63 17.63h-33.495c-9.697 0-17.63-7.934-17.63-17.63z"
        clipRule="evenodd"
      />
      <path
        fill="#323E66"
        fillRule="evenodd"
        d="M132.402 374.615h34.378v102.848c0 9.696-7.934 17.63-17.63 17.63h-16.748zM345.224 374.615h68.756v102.848c0 9.696-7.932 17.63-17.63 17.63h-33.495c-9.697 0-17.63-7.934-17.63-17.63z"
        clipRule="evenodd"
      />
      <path
        fill="#3D4A75"
        fillRule="evenodd"
        d="M379.601 374.615h34.379v102.848c0 9.696-7.933 17.63-17.63 17.63h-16.749z"
        clipRule="evenodd"
      />
      <path
        fill="#EE8700"
        d="M416.779 16H95.227c-13.882 0-25.135 11.253-25.135 25.135v362.301c0 13.881 11.253 25.135 25.135 25.135h321.552c13.882 0 25.135-11.254 25.135-25.135V41.135c0-13.882-11.253-25.135-25.135-25.135"
      />
      <path
        fill="#F89B00"
        fillRule="evenodd"
        d="M256.002 16h160.777c13.824 0 25.134 11.309 25.134 25.135v362.301c0 13.824-11.31 25.135-25.134 25.135H256.002z"
        clipRule="evenodd"
      />
      <path
        fill="#EE8700"
        fillRule="evenodd"
        d="M419.843 16.186c12.392 1.523 22.069 12.158 22.069 24.946v362.301c0 12.786-9.677 23.421-22.069 24.946z"
        clipRule="evenodd"
      />
      <path
        fill="#E9E9FF"
        fillRule="evenodd"
        d="m352.779 383.528 19.026-32.954h70.108v32.954z"
        clipRule="evenodd"
      />
      <path
        fill="#A83B00"
        fillRule="evenodd"
        d="M194.562 359.067a8.492 8.492 0 0 1 0-16.983h122.88a8.492 8.492 0 0 1 0 16.983zm15.28 32.952a8.492 8.492 0 0 1 0-16.983h92.318a8.492 8.492 0 0 1 0 16.983z"
        clipRule="evenodd"
      />
      <path
        fill="#B54500"
        fillRule="evenodd"
        d="M256.002 342.084h61.439a8.492 8.492 0 0 1 0 16.983h-61.439zm0 49.935v-16.983h46.16a8.492 8.492 0 0 1 0 16.983z"
        clipRule="evenodd"
      />
      <path
        fill="#B54500"
        d="M482.911 119.764h19.221c5.447 0 9.868 4.422 9.868 9.867v69.616c0 5.446-4.423 9.868-9.869 9.868H482.91c-5.447 0-9.869-4.422-9.869-9.868v-69.615c0-5.446 4.424-9.868 9.87-9.868M9.87 119.764h19.221c5.447 0 9.867 4.422 9.867 9.867v69.616c0 5.446-4.422 9.868-9.868 9.868H9.868c-5.446 0-9.868-4.422-9.868-9.868v-69.615c0-5.446 4.422-9.868 9.868-9.868z"
      />
      <path
        fill="#D3D3F2"
        d="M419.16 378.71c6.434-6.434 6.434-16.865 0-23.299-6.434-6.433-16.865-6.433-23.298 0-6.434 6.434-6.434 16.865 0 23.299 6.433 6.433 16.864 6.433 23.298 0"
      />
      <path
        fill="#E37200"
        fillRule="evenodd"
        d="M92.16 16.186c-12.392 1.523-22.069 12.158-22.069 24.946v362.301c0 12.786 9.679 23.421 22.07 24.946z"
        clipRule="evenodd"
      />
      <path
        fill="#E9E9FF"
        fillRule="evenodd"
        d="m159.224 383.524-19.026-32.954H70.091v32.954zM70.091 64.387h371.822v133.067c0 24.863-20.34 45.203-45.203 45.203H115.294c-24.863 0-45.203-20.342-45.203-45.203z"
        clipRule="evenodd"
      />
      <path
        fill="#E9E9FF"
        fillRule="evenodd"
        d="M256.002 64.387h185.911v133.067c0 24.863-20.34 45.203-45.203 45.203H256.002z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M256.002 64.387h185.911v133.067c0 24.863-20.34 45.203-45.203 45.203H256.002z"
        clipRule="evenodd"
      />
      <path
        fill="#7986BF"
        fillRule="evenodd"
        d="m274.868 242.655 20.397-35.329a8.49 8.49 0 0 1 7.33-4.246h93.473a8.492 8.492 0 0 1 0 16.983h-88.594l-13.043 22.592zM106.063 241.701l19.846-34.375a8.49 8.49 0 0 1 7.33-4.246h93.473a8.492 8.492 0 0 1 0 16.983h-88.594l-13.045 22.592h-9.78c-3.161 0-6.248-.329-9.23-.954"
        clipRule="evenodd"
      />
      <path
        fill="#E9E9FF"
        fillRule="evenodd"
        d="M441.914 64.387h-22.07v171.855c13.193-7.917 22.07-22.366 22.07-38.79z"
        clipRule="evenodd"
      />
      <path
        fill="#D3D3F2"
        fillRule="evenodd"
        d="M70.091 64.387h22.07v171.855c-13.193-7.917-22.07-22.366-22.07-38.79z"
        clipRule="evenodd"
      />
      <path
        fill="#D3D3F2"
        d="M108.191 382.815c8.854-2.093 14.335-10.967 12.242-19.821s-10.967-14.336-19.822-12.243-14.335 10.968-12.242 19.822 10.968 14.335 19.822 12.242"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h512v512H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const WellnessProgramIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <path
      fill="#60B7FE"
      fillRule="evenodd"
      d="M300.552 387.568c-.228-22.431-.231-33.258-.231-33.258.59-.992 49.925-17.574 86.501-39.037 15.024-8.816 23.261-18.244 36.982-23.362 11.966-4.462 22.239.025 24.081-15.209a12.98 12.98 0 0 0-5.278-12.079c-10.349-7.488-36.422 1.416-58.595 11.782-29.195 13.65-43.535 30.943-78.757 20.108-7.647-2.885-14.847-5.096-21.767-6.629-15.153-3.358-33.906-3.66-49.199-.786-8.089 1.521-16.529 3.993-25.597 7.415-35.221 10.835-49.56-6.458-78.757-20.108-22.173-10.366-48.246-19.271-58.594-11.782a12.98 12.98 0 0 0-5.279 12.079c1.843 15.233 12.115 10.747 24.082 15.209 13.72 5.117 21.957 14.545 36.981 23.362 36.577 21.463 85.912 38.046 86.502 39.037 0 0 .004 10.468-.231 33.258-19.701-.937-59.846-1.091-64.335 23.297q-2.166 11.767 15.27 25.156c30.417 18.26 54.074 27.426 86.053 38.083q3.276-22.149-6.666-34.62c-7.44-9.332-20.275-14.626-36.218-17.045a6.847 6.847 0 0 1 2.034-13.54c21.453 3.239 39.539 11.783 48.5 27.389 8.872-15.087 25.935-23.958 48.525-27.389a6.846 6.846 0 0 1 2.034 13.54c-15.989 2.427-28.793 7.734-36.218 17.045-10.532 13.21-6.87 19.973-8.695 34.582 31.921-10.642 55.557-19.808 85.937-38.045q19.112-14.676 14.673-27.402c-5.845-16.76-47.79-21.81-63.738-21.051"
      clipRule="evenodd"
    />
    <path
      fill="#F0B16E"
      d="M291.503 265.963c2.679-19.076-10.614-36.712-29.691-39.39-19.076-2.679-36.712 10.614-39.39 29.691-2.679 19.076 10.614 36.712 29.691 39.39 19.076 2.679 36.712-10.614 39.39-29.691"
    />
    <path
      fill="#FA6E85"
      fillRule="evenodd"
      d="M255.755 177.647c-85.147-44.984-83.432-142.324-33.849-139.698 9.97.527 21.818 6.792 35.342 16.642 13.541-9.286 25.446-15.205 35.327-15.556 50.23-1.78 49.53 96.156-36.82 138.612"
      clipRule="evenodd"
    />
    <path
      fill="#19CFBA"
      fillRule="evenodd"
      d="M187.58 121.139a6.85 6.85 0 0 1 0-13.699h33.57l11.182-20.648c2.588-4.795 9.483-4.806 12.074.061l20.224 37.343 7.118-13.143a6.83 6.83 0 0 1 6.02-3.6v-.013h52.655a6.85 6.85 0 1 1 0 13.699h-48.59l-11.15 20.586c-2.591 4.866-9.486 4.857-12.074.062l-20.256-37.404-6.909 12.757a6.85 6.85 0 0 1-6.229 3.999z"
      clipRule="evenodd"
    />
    <path
      fill="#FA6E85"
      fillRule="evenodd"
      d="M106.54 223.225c-2.772 5.52-11.111 8.425-17.117 9.876-13.818 3.339-25.425-8.741-32.286-19.478q-10.794-16.893-13.003-45.941c-1.124-14.796-1.741-27.96 10.606-38.826 10.064-8.854 21.394-5.186 31.967.549 6.977 3.785 12.819 9.16 19.552 17.814 5.705-7.333 10.929-12.311 16.733-15.963 11.349-7.137 25.157-12.097 36.135-1.679 12.899 12.244 11.059 28.702 9.169 44.849q-2.844 24.315-12.355 39.196c-6.861 10.738-17.362 22.303-31.179 18.964-6.004-1.45-15.45-3.841-18.222-9.361"
      clipRule="evenodd"
    />
    <path
      fill="#19CFBA"
      fillRule="evenodd"
      d="M106.262 147.216q-6.948-54.026 42.88-74.27 7.382 53.274-42.88 74.27"
      clipRule="evenodd"
    />
    <path
      fill="#FA6E85"
      fillRule="evenodd"
      d="M436.737 182.685h-56.108v28.039h-31.683v-69.779h31.683v28.039h56.108v-28.039h31.683v69.779h-31.683z"
      clipRule="evenodd"
    />
  </svg>
);

export const ParentalLeaveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <path
      fill="#FFCEC7"
      d="M227.474 75.757s36.263-11.08 65.229-33.083a100.64 100.64 0 0 1 60.9-20.36l71.529 2.578.376 108.237S269.021 151.52 227.474 75.757"
    />
    <path
      fill="#7AAEED"
      d="M425.393 24.079s-45.842-9.293-105.947 42.88a79.95 79.95 0 0 1-48.778 19.743 75.1 75.1 0 0 1-43.194-10.945S114.6 108.302 168.722 170.1c0 0-131.336 67.634-121.53 215.834 10.468 45.158 38.85 77.414 79.269 101.001h209.932c31.56-43.25 60.08-264.812 89-462.857"
    />
    <path
      fill="#FFCEC7"
      d="M47.192 385.934s-13.507 46.349 15.462 79.795a68.64 68.64 0 0 0 63.196 23.006 59.3 59.3 0 0 0 18.276-6.183c19.734-10.666 22.846-37.775 6.408-53.043a28.72 28.72 0 0 0-33.554-4.025l-9.197 5.139 3.964-4.272a12.33 12.33 0 0 0 .77-15.857 12.32 12.32 0 0 0-7.488-4.638 12.32 12.32 0 0 0-8.67 1.553c-11.23 6.781-31.512 11.938-49.167-21.475"
    />
    <path
      fill="#fff"
      d="M179.435 302.388c-16.872-19.283-42.181 6.025-42.181 6.025s-25.309-25.308-42.182-6.025c-17.767 20.306 8.678 37.777 8.678 37.777 21.538 15.817 33.504 29.111 33.504 29.111s11.965-13.294 33.504-29.111c0-.001 26.445-17.472 8.677-37.777"
    />
    <path
      fill="#497FCE"
      d="M204.365 180.562s46.08 12.037 81.145-18.874a4.052 4.052 0 0 1 6.515 4.3c-4.004 12.361-13.783 29.647-37.61 37.346zM412.911 486.936s3.276-30.912-18.149-76.921a127 127 0 0 1-10.165-74.2 281.5 281.5 0 0 1 16.869-59.958l-20.231-4.154-110.977-28.817-118.748-41.693s-28.338.149-37.566 25.213c55.234 3.435 104.691 32.675 139.862 78.991 25.231 33.227 41.062 72.754 44.656 114.32 3.622 41.841-6.227 67.219-6.227 67.219z"
    />
    <path
      fill="#497FCE"
      d="m380.945 63.147-47.206 112.572a32.814 32.814 0 0 1-37.608 19.287l-35.402-8.14-18.246 14.328 127.693 61.678 42.926-153.681z"
    />
    <path
      fill="#FFCEC7"
      d="M467.866 64.535c1.504-23.502-15.612-40.894-42.356-41.786-23.542-.784-39.858 13.7-45.023 42.787l-19.954 139.512a24.45 24.45 0 0 1-21.515 20.511 24.45 24.45 0 0 1-10.503-1.158c-62.105-22.784-123.16-45.012-159.793-54.305 0 0-37.314-10.24-72.434 17.561A29.34 29.34 0 0 0 83.4 206.242a19.113 19.113 0 0 0 23.567 22.528 54.3 54.3 0 0 0 9.379-3.421 61.13 61.13 0 0 1 33.75-5.513c12.372 1.639 28.577 6.667 47.893 19.047 37.967 24.322 79.781 54.897 146.893 78.856a60.623 60.623 0 0 0 76.175-33.346c18.863-44.451 41.996-144.68 46.809-219.858"
    />
  </svg>
);

export const ProfessionalDevelopmentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <path
      fill="#F3D55B"
      d="M379.586 428.138h97.104c19.501 0 35.31-15.809 35.31-35.31V75.035c0-19.501-15.809-35.31-35.31-35.31H35.31C15.81 39.725 0 55.534 0 75.035v317.793c0 19.501 15.809 35.31 35.31 35.31z"
    />
    <path
      fill="#fff"
      d="M317.793 357.518H88.276c-19.501 0-35.31-15.809-35.31-35.31V145.656c0-19.501 15.809-35.31 35.31-35.31h229.517z"
    />
    <path
      fill="#E4C05C"
      d="M317.793 366.345H88.276c-24.365-.029-44.109-19.773-44.138-44.138V145.656c.03-24.365 19.773-44.109 44.138-44.138h229.517a8.83 8.83 0 0 1 8.828 8.827v247.173a8.83 8.83 0 0 1-8.828 8.827M88.276 119.173c-14.626 0-26.483 11.856-26.483 26.483v176.551c0 14.626 11.857 26.483 26.483 26.483h220.69V119.173z"
    />
    <path
      fill="#547580"
      d="M220.69 242.759H97.104a8.828 8.828 0 0 1 0-17.655H220.69a8.828 8.828 0 0 1 0 17.655M220.69 207.448H97.104a8.827 8.827 0 1 1 0-17.655H220.69a8.827 8.827 0 0 1 8.827 8.828 8.827 8.827 0 0 1-8.827 8.827M220.69 172.138H97.104a8.828 8.828 0 0 1 0-17.656H220.69a8.83 8.83 0 0 1 8.827 8.828 8.83 8.83 0 0 1-8.827 8.828M97.103 331.034a8.828 8.828 0 0 1-3.53-16.923 52.4 52.4 0 0 0 16.772-9.834 22.84 22.84 0 0 0 6.832-16.834 8.828 8.828 0 0 1 17.091-3.601 36.2 36.2 0 0 0 15.139 19.191 8.14 8.14 0 0 0 5.826 1.5 4.46 4.46 0 0 0 1.986-3.945 8.828 8.828 0 0 1 17.073-3.717c.883 2.339 2.992 5.659 11.229 7.557l6.823 1.615a121.9 121.9 0 0 0 36.582 5.12 8.829 8.829 0 0 1 1.271 17.611 138.7 138.7 0 0 1-41.966-5.561l-6.674-1.581a40.4 40.4 0 0 1-13.003-5.252 19.9 19.9 0 0 1-7.062 4.679 23.91 23.91 0 0 1-20.718-2.649 47 47 0 0 1-11.732-9.533 41.5 41.5 0 0 1-6.18 7.944 67.9 67.9 0 0 1-22.228 13.48 8.7 8.7 0 0 1-3.53.733"
    />
    <path
      fill="#FF5364"
      d="M379.586 375.172v84.621a8.826 8.826 0 0 1-15.068 6.241l-20.242-20.241-20.242 20.241a8.827 8.827 0 0 1-15.068-6.241V251.586a13.44 13.44 0 0 0 9.445 3.884 12.9 12.9 0 0 0 4.679-.883 12.2 12.2 0 0 1 4.678-.882 13.72 13.72 0 0 1 12.359 7.944 13.45 13.45 0 0 0 12.27 7.857 13.32 13.32 0 0 0 9.181-3.619c.088-.089.265-.177.353-.265z"
    />
    <path
      fill="#DF4D60"
      d="M432.552 251.586v119.932a8.828 8.828 0 0 1-15.069 6.241l-20.242-20.242L377 377.759a8.827 8.827 0 0 1-15.069-6.241V265.586c5.172-4.572 12.974-4.457 18.008.265a13.32 13.32 0 0 0 9.181 3.62 13.45 13.45 0 0 0 12.27-7.857 13.72 13.72 0 0 1 12.359-7.945 12.2 12.2 0 0 1 4.679.883c1.491.582 3.077.882 4.678.883a13.44 13.44 0 0 0 9.446-3.849"
    />
    <path
      fill="#FB7B76"
      d="M473.07 190.147a13.32 13.32 0 0 1 3.62 9.181 13.45 13.45 0 0 1-7.857 12.27 13.72 13.72 0 0 0-7.945 12.359 12.2 12.2 0 0 0 .883 4.678c.582 1.491.882 3.078.883 4.679-.037 7.273-5.797 13.227-13.065 13.506-7.057.259-12.718 5.92-12.977 12.977a13.08 13.08 0 0 1-4.06 9.18 13.43 13.43 0 0 1-9.446 3.884 12.9 12.9 0 0 1-4.678-.882 12.2 12.2 0 0 0-4.679-.883 13.72 13.72 0 0 0-12.359 7.945 13.45 13.45 0 0 1-12.27 7.856 13.32 13.32 0 0 1-9.181-3.619 13.374 13.374 0 0 0-18.008-.265c-.088.088-.265.177-.353.265a13.32 13.32 0 0 1-9.181 3.619 13.45 13.45 0 0 1-12.27-7.856 13.72 13.72 0 0 0-12.359-7.945 12.2 12.2 0 0 0-4.678.883 12.9 12.9 0 0 1-4.679.882 13.43 13.43 0 0 1-9.446-3.884 13.08 13.08 0 0 1-4.06-9.18c-.259-7.057-5.92-12.718-12.977-12.977-7.268-.279-13.027-6.233-13.065-13.506.001-1.601.301-3.188.883-4.679.598-1.486.898-3.076.883-4.678a13.72 13.72 0 0 0-7.945-12.359 13.45 13.45 0 0 1-7.857-12.27 13.33 13.33 0 0 1 3.62-9.181c4.826-5.169 4.826-13.192 0-18.361a13.33 13.33 0 0 1-3.62-9.181 13.45 13.45 0 0 1 7.857-12.27 13.72 13.72 0 0 0 7.945-12.359 12.2 12.2 0 0 0-.883-4.679 12.9 12.9 0 0 1-.883-4.678c.038-7.274 5.797-13.228 13.065-13.507 7.057-.258 12.718-5.919 12.977-12.976.278-7.268 6.232-13.028 13.506-13.065 1.601.001 3.187.3 4.679.883a12.2 12.2 0 0 0 4.678.883 13.72 13.72 0 0 0 12.359-7.945 13.45 13.45 0 0 1 12.27-7.857 13.32 13.32 0 0 1 9.181 3.62c5.169 4.825 13.192 4.825 18.361 0a13.507 13.507 0 0 1 21.451 4.237 13.72 13.72 0 0 0 12.359 7.945 12.2 12.2 0 0 0 4.679-.883 12.9 12.9 0 0 1 4.678-.883c7.274.037 13.228 5.797 13.506 13.065.259 7.057 5.92 12.718 12.977 12.976 7.268.279 13.028 6.233 13.065 13.507a12.9 12.9 0 0 1-.883 4.678 12.2 12.2 0 0 0-.883 4.679 13.72 13.72 0 0 0 7.945 12.359 13.45 13.45 0 0 1 7.857 12.27 13.32 13.32 0 0 1-3.62 9.181c-4.826 5.169-4.826 13.192 0 18.361"
    />
    <path
      fill="#fff"
      d="M370.759 242.76c34.127 0 61.793-27.666 61.793-61.793s-27.666-61.793-61.793-61.793c-34.128 0-61.793 27.666-61.793 61.793s27.665 61.793 61.793 61.793"
    />
    <path
      fill="#F3D55B"
      d="M370.759 251.587c-39.003 0-70.621-31.618-70.621-70.621s31.618-70.62 70.621-70.62 70.62 31.618 70.62 70.62c-.043 38.985-31.636 70.577-70.62 70.621m0-123.586c-29.252 0-52.966 23.713-52.966 52.965s23.714 52.966 52.966 52.966 52.965-23.714 52.965-52.966c-.029-29.24-23.725-52.936-52.965-52.965"
    />
  </svg>
);

export const FamilyInsuranceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
    viewBox="0 0 512 512"
  >
    <g clipPath="url(#a)">
      <path
        fill="#705050"
        d="M142.969 217.031A24.05 24.05 0 0 0 120 200H64a40.05 40.05 0 0 0-40 40v48a7.994 7.994 0 0 0 8 8h120a7.98 7.98 0 0 0 5.658-2.342A8 8 0 0 0 160 288v-48a24.04 24.04 0 0 0-17.031-22.969M288 264h-64a32.03 32.03 0 0 0-32 32v48a7.98 7.98 0 0 0 2.342 5.658A8 8 0 0 0 200 352h112a7.98 7.98 0 0 0 5.658-2.342A8 8 0 0 0 320 344v-48a32.03 32.03 0 0 0-32-32M479.258 225.117A32.066 32.066 0 0 0 448 200h-48a56.07 56.07 0 0 0-56 56v120a7.98 7.98 0 0 0 2.342 5.658A8 8 0 0 0 352 384h136a7.98 7.98 0 0 0 5.658-2.342A8 8 0 0 0 496 376V248a24.05 24.05 0 0 0-16.742-22.883"
      />
      <path
        fill="#4CBFBF"
        d="m483.945 353.344-41.476-12.977a8 8 0 0 0-2.391-.367h-40.156c-.811 0-1.617.124-2.391.367l-41.476 12.977a39.83 39.83 0 0 0-20.32 14.461A39.84 39.84 0 0 0 328 391.516V496a7.98 7.98 0 0 0 2.342 5.658A8 8 0 0 0 336 504h168a7.98 7.98 0 0 0 5.658-2.342A8 8 0 0 0 512 496V391.516a39.84 39.84 0 0 0-7.735-23.711 39.83 39.83 0 0 0-20.32-14.461"
      />
      <path
        fill="#FF3B57"
        d="m155.977 353.336-41.336-12.969a8.1 8.1 0 0 0-2.399-.367H71.758a8.1 8.1 0 0 0-2.399.367l-41.328 12.969A39.82 39.82 0 0 0 0 391.5V496a7.994 7.994 0 0 0 8 8h168a7.98 7.98 0 0 0 5.658-2.342A8 8 0 0 0 184 496V391.5a39.83 39.83 0 0 0-7.723-23.7 39.83 39.83 0 0 0-20.3-14.464"
      />
      <path
        fill="#FFCB5B"
        d="M344 40a124.16 124.16 0 0 1-82.344-29.656 8.02 8.02 0 0 0-11.297-.016A124.15 124.15 0 0 1 168 40a7.994 7.994 0 0 0-8 8v68.789a127.704 127.704 0 0 0 93.898 122.93 8 8 0 0 0 4.211 0A127.705 127.705 0 0 0 352 116.789v-68.79a7.99 7.99 0 0 0-2.342-5.657A8 8 0 0 0 344 40"
      />
      <path
        fill="#F4A947"
        d="M321.156 62.352a151.8 151.8 0 0 1-60.781-22.868 8.01 8.01 0 0 0-8.75 0 151.8 151.8 0 0 1-60.781 22.868A8 8 0 0 0 184 70.265v46.524a103.525 103.525 0 0 0 69.375 97.648 8 8 0 0 0 5.266 0A103.534 103.534 0 0 0 328 116.789V70.265a8 8 0 0 0-6.844-7.913"
      />
      <path
        fill="#E28C37"
        d="M248 144a7.97 7.97 0 0 1-5.656-2.344l-16-16a8 8 0 0 1 5.671-13.604 8 8 0 0 1 5.641 2.292L248 124.687l26.344-26.344a7.995 7.995 0 0 1 8.741-1.774 8 8 0 0 1 4.95 7.42 8.01 8.01 0 0 1-2.379 5.667l-32 32A7.97 7.97 0 0 1 248 144"
      />
      <path
        fill="#3083DC"
        d="m313.695 394.18-39.757-9.938A7.7 7.7 0 0 0 272 384h-32a7.7 7.7 0 0 0-1.938.242l-39.757 9.938A39.94 39.94 0 0 0 168 432.984V496a7.98 7.98 0 0 0 2.342 5.658A8 8 0 0 0 176 504h160a7.98 7.98 0 0 0 5.658-2.342A8 8 0 0 0 344 496v-63.016a39.936 39.936 0 0 0-30.305-38.804"
      />
      <path
        fill="#1B67CC"
        d="M304 448v56h-16v-56a8 8 0 1 1 16 0M224 448v56h-16v-56a8 8 0 1 1 16 0"
      />
      <path
        fill="#D62B40"
        d="M144 408v96h-16v-96a8 8 0 1 1 16 0M56 408v96H40v-96a8 8 0 1 1 16 0"
      />
      <path
        fill="#EFACAC"
        d="M276 364.75a8 8 0 0 0-7.992 0 23.91 23.91 0 0 1-24.016 0 7.988 7.988 0 0 0-7.997.003A8 8 0 0 0 232 371.68V392a24.003 24.003 0 0 0 24 24 24 24 0 0 0 24-24v-20.32a8 8 0 0 0-4-6.93M288 320a7.98 7.98 0 0 0-5.658 2.342A8 8 0 0 0 280 328v16a24 24 0 0 1-3.117 11.812 8.01 8.01 0 0 0-.179 7.55 8.01 8.01 0 0 0 6.179 4.341c1.698.199 3.407.298 5.117.297 17.945 0 32-10.539 32-24s-14.055-24-32-24M235.305 363.359a7.97 7.97 0 0 0-.188-7.554A23.94 23.94 0 0 1 232 344v-16a7.98 7.98 0 0 0-2.342-5.658A8 8 0 0 0 224 320c-17.945 0-32 10.539-32 24s14.055 24 32 24c1.71.005 3.419-.094 5.117-.297a7.99 7.99 0 0 0 6.188-4.344M115.906 314.781a8.01 8.01 0 0 0-8.25.446 28.5 28.5 0 0 1-31.312 0 8.006 8.006 0 0 0-12.5 6.64l.07 26.164a28.085 28.085 0 0 0 56.172-.008l.07-26.156a7.99 7.99 0 0 0-4.25-7.086M132 263.999a29.5 29.5 0 0 0-5.484.461 8 8 0 0 0-6.516 7.859v19.68a26.9 26.9 0 0 1-1.414 8.696 7.995 7.995 0 0 0 2.638 8.88 8 8 0 0 0 2.932 1.448 31 31 0 0 0 7.844.976 26.26 26.26 0 0 0 28-24 26.263 26.263 0 0 0-28-24M65.414 300.695A26.9 26.9 0 0 1 64 291.999v-19.68a8 8 0 0 0-6.516-7.859 29.4 29.4 0 0 0-5.484-.461 26.267 26.267 0 0 0-28 24 26.26 26.26 0 0 0 28 24 31 31 0 0 0 7.844-.976 7.997 7.997 0 0 0 5.57-10.328M443.906 314.781a8.01 8.01 0 0 0-8.25.446 28.5 28.5 0 0 1-31.312 0 8.01 8.01 0 0 0-8.251-.446 8.01 8.01 0 0 0-4.249 7.086l.07 26.164a28.085 28.085 0 0 0 56.172-.008l.07-26.156a7.99 7.99 0 0 0-4.25-7.086"
      />
      <path
        fill="#3BA5AD"
        d="M480 427.28v1.44a34.7 34.7 0 0 1-8 22.32V504h-16v-56a8.26 8.26 0 0 1 2.32-5.68 18.94 18.94 0 0 0 5.68-13.6v-1.44a18.94 18.94 0 0 0-5.68-13.6 8.04 8.04 0 0 1-2.33-5.673 8.037 8.037 0 0 1 8.017-8.017 8.04 8.04 0 0 1 5.673 2.33A35.37 35.37 0 0 1 480 427.28M381.68 442.32A8.26 8.26 0 0 1 384 448v56h-16v-52.96a34.7 34.7 0 0 1-8-22.32v-1.44a35.37 35.37 0 0 1 10.32-24.96 8.036 8.036 0 0 1 11.337.023 8.04 8.04 0 0 1 2.353 5.664 8.04 8.04 0 0 1-2.33 5.673 18.93 18.93 0 0 0-5.68 13.6v1.44a18.94 18.94 0 0 0 5.68 13.6"
      />
      <path
        fill="#FFCACA"
        d="M288 304h-64a7.98 7.98 0 0 0-5.658 2.342A8 8 0 0 0 216 312v32a40 40 0 0 0 11.716 28.284 39.996 39.996 0 0 0 56.568 0A40 40 0 0 0 296 344v-32a7.98 7.98 0 0 0-2.342-5.658A8 8 0 0 0 288 304M132.922 241.695a7.93 7.93 0 0 0-6.86-1.453l-15.374 3.844A131.8 131.8 0 0 1 78.859 248H56a8 8 0 0 0-5.658 2.342A8 8 0 0 0 48 256v36a44 44 0 1 0 88 0v-44a8 8 0 0 0-3.078-6.305M460.922 257.694a7.89 7.89 0 0 0-6.86-1.453l-15.374 3.844a131.8 131.8 0 0 1-31.829 3.914H384a7.98 7.98 0 0 0-5.658 2.342 8 8 0 0 0-2.342 5.658v20a44.003 44.003 0 0 0 44 44 44.003 44.003 0 0 0 44-44v-28a8 8 0 0 0-3.078-6.305"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h512v512H0z" />
      </clipPath>
    </defs>
  </svg>
);
